<div class="modal-header">
  <h5 class="modal-title">Chi Tiết Danh Mục</h5>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="mediaTypeForm" (ngSubmit)="onSubmit()" class="form-group row">
    <!-- Left Column -->
    <div class="col-md-6">
      <!-- Name -->
      <div class="form-group">
        <label for="name">Tên
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập tên loại phương tiện"></i>
        </label>
        <input formControlName="name" type="text" id="name" class="form-control"
               placeholder="Sách, DVD, v.v.">
      </div>

      <!-- Code -->
      <div class="form-group">
        <label for="code">Mã
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập mã duy nhất"></i>
        </label>
        <input formControlName="code" type="text" id="code" class="form-control"
               placeholder="BK123">
      </div>

      <!-- Parent Code -->
      <div class="form-group">
        <label for="parentCode">Mã Cha
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập mã cha"></i>
        </label>
        <input formControlName="parentCode" type="text" id="parentCode" class="form-control"
               placeholder="Nhập mã cha (tùy chọn)">
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <!-- Not for Loan -->
      <div class="form-group">
        <label for="notForLoan">Không Cho Mượn
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Đánh dấu nếu không cho mượn"></i>
        </label>
        <input formControlName="notForLoan" type="checkbox" id="notForLoan">
      </div>

      <!-- Rental Charge -->
      <div class="form-group">
        <label for="rentalCharge">Phí Thuê
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập phí thuê"></i>
        </label>
        <div class="input-group">
          <input formControlName="rentalCharge" type="number" step="0.01" id="rentalCharge" class="form-control"
                 placeholder="5.00">
          <div class="input-group-append">
            <span class="input-group-text">USD</span>
          </div>
        </div>
      </div>

      <!-- Daily Rental Charge -->
      <div class="form-group">
        <label for="dailyRentalCharge">Phí Thuê Theo Ngày
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập phí thuê theo ngày"></i>
        </label>
        <div class="input-group">
          <input formControlName="dailyRentalCharge" type="number" step="0.01" id="dailyRentalCharge" class="form-control"
                 placeholder="1.00">
          <div class="input-group-append">
            <span class="input-group-text">USD/ngày</span>
          </div>
        </div>
      </div>

      <!-- Hourly Rental Charge -->
      <div class="form-group">
        <label for="hourlyRentalCharge">Phí Thuê Theo Giờ
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập phí thuê theo giờ"></i>
        </label>
        <div class="input-group">
          <input formControlName="hourlyRentalCharge" type="number" step="0.01" id="hourlyRentalCharge" class="form-control"
                 placeholder="0.50">
          <div class="input-group-append">
            <span class="input-group-text">USD/hour</span>
          </div>
        </div>
      </div>

      <!-- Default Replacement Cost -->
      <div class="form-group">
        <label for="defaultReplacementCost">Phí Thay Thế Mới
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập phí thay thế"></i>
        </label>
        <div class="input-group">
          <input formControlName="defaultReplacementCost" type="number" step="0.01" id="defaultReplacementCost" class="form-control"
                 placeholder="25.00">
          <div class="input-group-append">
            <span class="input-group-text">USD</span>
          </div>
        </div>
      </div>

      <!-- Processing Fee -->
      <div class="form-group">
        <label for="processingFee">Phí Xử Lý (khi mất)
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập phí xử lý"></i>
        </label>
        <div class="input-group">
          <input formControlName="processingFee" type="number" step="0.01" id="processingFee" class="form-control"
                 placeholder="10.00">
          <div class="input-group-append">
            <span class="input-group-text">USD</span>
          </div>
        </div>
      </div>

      <!-- Checkin Message -->
      <div class="form-group">
        <label for="checkinMessage">Thông Điệp Kiểm Tra
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập thông điệp kiểm tra"></i>
        </label>
        <input formControlName="checkinMessage" type="text" id="checkinMessage" class="form-control"
               placeholder="Thông điệp khi kiểm tra">
      </div>

      <!-- Library Limitations -->
      <div class="form-group">
        <label for="libraryLimitations">Giới Hạn Thư Viện
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Nhập giới hạn thư viện"></i>
        </label>
        <input formControlName="libraryLimitations" type="text" id="libraryLimitations" class="form-control"
               placeholder="Nhập bất kỳ giới hạn nào">
      </div>
    </div>

    <!-- Submit Button -->
    <div class="form-group col-md-12">
      <button type="submit" class="btn btn-outline-primary">
        <i class="fas fa-save"></i> Save
      </button>
     <!--  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        <i class="fas fa-times"></i> Cancel
      </button> -->
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="button-group">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
      <i class="fas fa-times"></i> Close
    </button>
  </div>
</div>
